import { trackEvent } from '../../support-and-tracking/analytics-actions';
import styles from './modal-cookie-consent.module.less';
import { ToggleSwitch, Tooltip } from '@sb1/ffe-form-react';
import { BodyText, Heading2, StrongText } from '@sb1/ffe-core-react';

const TRACKING_CATEGORY = 'cookie-consent';
const TRACKING_NAME = 'administration';

const AdministerCookieContent = ({
    statisticsCookiesConsent,
    setStatisticsCookiesConsent,
    retargetingCookiesConsent,
    setRetargetingCookiesConsent,
    statisticsInfo,
    setStatisticsInfo,
    retargetingInfo,
    setRetargetingInfo,
}) => {
    return (
        <>
            <Heading2 id={'consent-modal-title'} noMargin>
                Valg av cookies
            </Heading2>
            <ul className={styles.cookieUsageList}>
                <li>
                    <ToggleSwitch checked hideOnOff readOnly>
                        <BodyText className={styles.requiredCookies}>
                            <StrongText>Nødvendige</StrongText>
                            Tekniske cookies som er nødvendige for å kunne bruke våre nettsider optimalt. Kan ikke skrus
                            av.
                        </BodyText>
                    </ToggleSwitch>
                </li>
                <li>
                    <ToggleSwitch
                        hideOnOff
                        checked={statisticsCookiesConsent}
                        onChange={() => {
                            setStatisticsCookiesConsent(!statisticsCookiesConsent);
                            trackEvent(TRACKING_CATEGORY, TRACKING_NAME, {
                                action: 'consent-statistics-checkbox',
                                value: statisticsCookiesConsent,
                            });
                        }}
                    >
                        <BodyText className={styles.requiredCookies}>
                            <StrongText>
                                Statistikk
                                <Tooltip
                                    aria-controls={'statistics-info'}
                                    onClick={() => setStatisticsInfo(!statisticsInfo)}
                                />
                            </StrongText>
                            <div hidden={!statisticsInfo} id={'statistics-info'}>
                                Vi lagrer statistikk over bruk av nettsiden. Denne informasjonen hjelper oss til å
                                forstå hvordan nettsidene blir brukt, noe som gjør at vi kan forbedre oss
                            </div>
                        </BodyText>
                    </ToggleSwitch>
                </li>
                <li>
                    <ToggleSwitch
                        hideOnOff
                        checked={retargetingCookiesConsent}
                        onChange={() => {
                            setRetargetingCookiesConsent(!retargetingCookiesConsent);
                            trackEvent(TRACKING_CATEGORY, TRACKING_NAME, {
                                action: 'consent-retargeting-checkbox',
                                value: retargetingCookiesConsent,
                            });
                        }}
                    >
                        <BodyText className={styles.requiredCookies}>
                            <StrongText>
                                Målrettet annonsering
                                <Tooltip
                                    aria-controls={'acceptRetargetingCookies-info'}
                                    onClick={() => setRetargetingInfo(!retargetingInfo)}
                                />
                            </StrongText>
                            <div hidden={!retargetingInfo} id={'acceptRetargetingCookies-info'}>
                                Dette gir oss muligheten til å vise deg mer relevante annonser for Spleis på andre
                                nettsteder
                            </div>
                        </BodyText>
                    </ToggleSwitch>
                </li>
            </ul>
        </>
    );
};

export default AdministerCookieContent;
